export const buildFinancialProductConfiguration = (financialProductConfiguration, setVat) => {

    financialProductConfiguration["MSRP"] = +Number((Math.round(financialProductConfiguration.MSRP + "e" + 2)  + "e-" + 2));
    financialProductConfiguration["MSRPWDiscount"] = +Number((Math.round(financialProductConfiguration.MSRPWDiscount + "e" + 2)  + "e-" + 2));
    financialProductConfiguration["totalInstallment"] = +Number((Math.round(financialProductConfiguration.totalInstallment + "e" + 2)  + "e-" + 2));
    if (setVat) {
        financialProductConfiguration["nissanVehiclePriceNoVAT"] = +Number((Math.round(financialProductConfiguration.nissanVehiclePriceNoVAT + "e" + 2)  + "e-" + 2));
        if(financialProductConfiguration.BPM){
            financialProductConfiguration["BPM"] = +Number((Math.round(financialProductConfiguration.BPM + "e" + 2)  + "e-" + 2));
        }
    }

    return financialProductConfiguration;

};